import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import { BatchSuggestionWithGroupsSchema } from "@redotech/redo-fulfillment-operations-common/batch-suggestion";
import * as z from "zod";

export const getBatchSuggestionByKey = {
  name: "getBatchSuggestionByKey" as const,
  input: z.object({
    batchKey: z.string(),
    advancedFiltersInput: AdvancedFilterInputSchema,
  }),
  output: z.object({ suggestion: BatchSuggestionWithGroupsSchema.nullish() }),
};
